import responseRate from '../../Actions/responseRate';
const { types } = responseRate;

const initialState = {
    responseRateData: null,
    isLoading: false,
    error: null
};

const responseRateReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_SERVICE_RESPONSE_RATE:
            return {
                ...state,
                isLoading: true,
                error: null
            };
        case types.GET_SERVICE_RESPONSE_RATE_SUCCESS:
            return {
                ...state,
                responseRateData: action.data,
                isLoading: false,
                error: null
            };
        case types.GET_SERVICE_RESPONSE_RATE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        default:
            return state;
    }
}

export default responseRateReducer;

